import React from 'react';

// Components
import * as S from './Styled';
import Icon from '../../Icon';
import Spinner from '../../Spinner';

// Store
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../actions';

// Utils
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const User = ({ icon, menu, onClose }) => {
  const dispatch = useDispatch();
  const authState = useSelector(state => state.auth);
  const { user, isLoading } = authState;
  const { first_name, last_name, email } = user;
  let history = useHistory();
  let { t } = useTranslation();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return isLoading ? (
    <Spinner size="small" />
  ) : (
    <S.ExtUser>
      <S.Title to="/profile/history">
        <S.IconWrap>
          <Icon name={icon} />
        </S.IconWrap>
        <S.Name>{`${first_name} ${last_name}`}</S.Name>
      </S.Title>
      <S.Dropdown>
        <S.Header>
          <S.HeaderName>{`${first_name} ${last_name}`}</S.HeaderName>
          {email !== null ? <S.Email>{`${email}`}</S.Email> : null}
        </S.Header>
        <S.Nav>
          {menu !== undefined &&
            menu.map(({ id, label, value }) => (
              <S.NavItem key={id} onClick={handleClose}>
                <S.NavLink to={value}>{t(label)}</S.NavLink>
              </S.NavItem>
            ))}
        </S.Nav>
        <S.Divider />
        <S.LogoutLink
          onClick={() => {
            dispatch(logout());
            history.go();
          }}
        >
          {t('labels.log_out')}
        </S.LogoutLink>
      </S.Dropdown>
      <S.Overlay />
    </S.ExtUser>
  );
};

export default User;
